<template>
    <div class="not-found-container">
        <!-- 插图部分 -->
        <div class="illustration">
            <img src="@/assets/images/404_images/404.png" alt="404 Not Found">
        </div>

        <!-- 文字内容 -->
        <div class="content">
            <h1>404</h1>
            <h2>哎呀！页面找不到了</h2>
            <p>您访问的页面可能已被移除、重命名或暂时不可用</p>

            <!-- 操作按钮 -->
            <div class="actions">
                <el-button type="primary" @click="goHome">返回首页</el-button>
                <el-button @click="goBack">返回上一页</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goHome = () => {
    router.push('/main')
}

const goBack = () => {
    router.go(-1)
}
</script>

<style scoped>
.not-found-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
    text-align: center;
    background-color: #f8f9fa;
}

.illustration {
    max-width: 300px;
    margin-bottom: 2rem;
}

.illustration img {
    width: 100%;
    height: auto;
}

.content h1 {
    font-size: 5rem;
    margin: 0;
    color: #dc3545;
}

.content h2 {
    font-size: 2rem;
    margin: 1rem 0;
    color: #343a40;
}

.content p {
    font-size: 1.1rem;
    color: #6c757d;
    margin-bottom: 2rem;
}

.actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

@media (max-width: 768px) {
    .content h1 {
        font-size: 3rem;
    }

    .content h2 {
        font-size: 1.5rem;
    }
}
</style>